import {
  GET_COLLECTIONS,
  GET_COLLECTIONS_ERROR,
  GET_COLLECTIONS_SUCCESS,
  CREATE_COLLECTION,
  CREATE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_ERROR,
  UPDATE_COLLECTION,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_ERROR,
  DELETE_COLLECTION,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_ERROR,
  SET_CREATING_COLLECTION,
  SET_EDITING_COLLECTION,
  SET_DELETING_COLLECTION,
  INSPECT_COLLECTION,
} from '../contants';

export const getCollections = () => ({
  type: GET_COLLECTIONS,
});
export const getCollectionsSuccess = (collections) => ({
  type: GET_COLLECTIONS_SUCCESS,
  payload: collections,
});
export const getCollectionsError = (message) => ({
  type: GET_COLLECTIONS_ERROR,
  payload: message,
});

export const inspectCollection = (collectionId) => ({
  type: INSPECT_COLLECTION,
  payload: collectionId,
});

export const createCollection = (collection, history) => ({
  type: CREATE_COLLECTION,
  payload: { collection, history },
});
export const createCollectionSuccess = (collection) => ({
  type: CREATE_COLLECTION_SUCCESS,
  payload: collection,
});
export const createCollectionError = (message) => ({
  type: CREATE_COLLECTION_ERROR,
  payload: message,
});

export const updateCollection = (collection) => ({
  type: UPDATE_COLLECTION,
  payload: collection,
});
export const updateCollectionSuccess = (collection) => ({
  type: UPDATE_COLLECTION_SUCCESS,
  payload: collection,
});
export const updateCollectionError = (message) => ({
  type: UPDATE_COLLECTION_ERROR,
  payload: message,
});

export const deleteCollection = (collection, history) => ({
  type: DELETE_COLLECTION,
  payload: { collection, history },
});
export const deleteCollectionSuccess = (collection) => ({
  type: DELETE_COLLECTION_SUCCESS,
  payload: collection,
});
export const deleteCollectionError = (message) => ({
  type: DELETE_COLLECTION_ERROR,
  payload: message,
});

export const setCreatingCollection = (value) => ({
  type: SET_CREATING_COLLECTION,
  payload: value,
});

export const setEditingCollection = (collection) => ({
  type: SET_EDITING_COLLECTION,
  payload: collection,
});

export const setDeletingCollection = (collection) => ({
  type: SET_DELETING_COLLECTION,
  payload: collection,
});
